import React from "react";
import banner from "./assets/000.png";
import image01 from "./assets/001.png";
import image02 from "./assets/002.png";
import image03 from "./assets/003.png";
import image04 from "./assets/004.png";
import image05 from "./assets/005.png";

export const Prevention = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const preventionCards = [
    {
      image: image01,
      title: "Prevenção Primária",
      description: "Ações preventivas antes do início do uso de substâncias",
    },
    {
      image: image02,
      title: "Prevenção Secundária",
      description: "Intervenção precoce para reduzir danos",
    },
    {
      image: image03,
      title: "Prevenção Terciária",
      description: "Reabilitação e reintegração social",
    },
    {
      image: image04,
      title: "Educação e Conscientização",
      description: "Campanhas e programas educacionais",
    },
    {
      image: image05,
      title: "Apoio Familiar",
      description: "Orientação e suporte para famílias",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            PREVENÇÃO
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            A prevenção é fundamental para combater as dependências químicas e
            promover uma sociedade mais saudável.
          </p>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center">
            <img
              src={banner}
              alt="Campanha de Prevenção"
              className="w-full max-w-4xl mx-auto rounded-3xl shadow-2xl hover:shadow-3xl transition-shadow duration-500"
            />
          </div>
        </div>
      </section>

      {/* Prevention Cards Section */}
      <section className="py-20 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold font-montserrat mb-6 bg-gradient-to-r from-brand-yellow to-white bg-clip-text text-transparent">
              Estratégias de Prevenção
            </h2>
            <p className="text-xl font-roboto text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Conheça as diferentes abordagens e estratégias que utilizamos para
              prevenir o uso de substâncias e promover a saúde mental.
            </p>
          </div>

          <div className="space-y-8">
            {/* Primeira linha - 3 imagens */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {preventionCards.slice(0, 3).map((card, index) => (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-brand-blue/20 to-transparent p-6 rounded-3xl border border-brand-blue/30 hover:border-brand-yellow/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-brand-yellow/20"
                >
                  <div className="overflow-hidden rounded-2xl mb-4 aspect-[4/5] md:aspect-[3/4]">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="text-center">
                    <h3 className="text-2xl font-bold font-montserrat mb-3 text-white">
                      {card.title}
                    </h3>
                    <p className="text-gray-300 font-roboto leading-relaxed">
                      {card.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Segunda linha - 2 imagens centralizadas */}
            <div className="flex justify-center">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
                {preventionCards.slice(3, 5).map((card, index) => (
                  <div
                    key={index + 3}
                    className="group bg-gradient-to-br from-brand-blue/20 to-transparent p-6 rounded-3xl border border-brand-blue/30 hover:border-brand-yellow/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-brand-yellow/20"
                  >
                    <div className="overflow-hidden rounded-2xl mb-4 aspect-[4/5] md:aspect-[3/4]">
                      <img
                        src={card.image}
                        alt={card.title}
                        className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="text-center">
                      <h3 className="text-2xl font-bold font-montserrat mb-3 text-white">
                        {card.title}
                      </h3>
                      <p className="text-gray-300 font-roboto leading-relaxed">
                        {card.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
            Faça Parte da Prevenção
          </h2>
          <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
            A prevenção começa com informação e conscientização. Junte-se a nós
            nessa missão de promover uma sociedade mais saudável.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
            >
              Fale Conosco
            </a>
            <a
              href="#quemSomos"
              onClick={() => scrollToSection("quemSomos")}
              className="border-2 border-white text-white font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
            >
              Conheça-nos
            </a>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};
